const article = {
    id: 'live-boxes',
    title: 'Live Boxes',
    summary: 'See outbound boxes shipped and audit boxes passed on a day, including earlier days.',
    publishedAt: '2026-11-02',
    tags: ['outbound', 'audit'],
    sections: [
        {
            type: 'paragraph',
            text: 'Live Boxes shows the outbound boxes shipped and the audit boxes that passed on a calendar day in Europe/Berlin. Leave the date empty for today, or pick an earlier day.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Live Boxes in the sidebar, next to Live Outbound.',
                'Read the two totals: outbound boxes shipped, and audit boxes passed.',
                'The totals at the top are how many boxes were done. Each card is one box, with its number.',
                'Turn on Auto Reload to refresh today’s counts.',
            ],
        },
    ],
};

export default article;
